<template>
  <section class="blockquote">
    <slot></slot>
  </section>
</template>

<script>
export default {
  components: {
    // 'render-title':
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';

.blockquote {
  padding-left: sizeTrans($space_10);
  border-left: 2px solid $color_mb5_back;
  box-sizing: border-box;
}
</style>